import Box from '@mui/material/Box';

export const CARD_NUMBER = 'card-number';
export const CARD_DATE = 'card-date';
export const CARD_CVC = 'card-cvv';
export const CARD_POSTAL = 'card-postal-code';

interface CardElementProps {
  id: string;
}

const CardElement = ({ id }: CardElementProps) => (
  <Box
    sx={{
      boxSizing: `content-box`,
      display: 'flex',
      height: '23px',
      padding: '14px 0 14px 12px',
      width: '100%'
    }}
  >
    <div id={id} />
  </Box>
);

export const CardNumberElement = () => <CardElement id={CARD_NUMBER} />;
export const CardExpiryElement = () => <CardElement id={CARD_DATE} />;
export const CardCvcElement = () => <CardElement id={CARD_CVC} />;
export const CardPostalElement = () => <CardElement id={CARD_POSTAL} />;
